import { DateTime } from "luxon";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { Case, User } from "pwapi";

import { recallReport } from "shared/actions/caseDetailActions";
import useLuxonTimer from "shared/hooks/useLuxonTimer";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import { PathologyWatchButton } from "./customInputs/buttons/Button";
import { DialogEnum } from "./viewer/dialogs/Dialog";

const RecallReportButton = ({
  currentUser,
  caseDetail,
  dialog,
  setDialog,
}: {
  currentUser?: User;
  caseDetail: CaseDetailState;
  dialog?: DialogEnum | null;
  setDialog?: Function;
}) => {
  const dispatch = useDispatch();
  const { isTimerRunning, setIsTimerRunning } = useLuxonTimer(
    caseDetail.transmitting_at
      ? DateTime.fromISO(caseDetail.transmitting_at)
      : undefined
  );

  const handleRecallReport = useCallback(() => {
    caseDetail?.id && dispatch(recallReport(caseDetail.id));
    setIsTimerRunning(false);
    dialog?.includes("diagnosis") && setDialog && setDialog(null);
  }, [caseDetail, dialog]);

  return isTimerRunning &&
    caseDetail.status === Case.status.LIS_PENDING &&
    (currentUser?.is_superuser ||
      (currentUser?.id &&
        currentUser.id === caseDetail.active_assignment?.id)) ? (
    <PathologyWatchButton color="red" onClick={handleRecallReport}>
      Recall Report
    </PathologyWatchButton>
  ) : null;
};

export default RecallReportButton;
